export default __webpack_public_path__ + "static/media/adi.e6468606.png";